import React from 'react'
import styles from './EmptyOrSkippedBanner.module.css'

interface Props {
  /** True when the parsed workbook had zero data rows. */
  empty: boolean
  /** Names of sheets present in the workbook but not matched to any ObjectType. */
  skippedSheets: string[]
}

/**
 * Warning banner rendered above ImportSummary when:
 *   - the workbook is empty (`empty === true`), OR
 *   - parser encountered sheets not matching any active ObjectType.
 *
 * Pure presentational component — no state, no MUI dependency.
 * Returns `null` when neither condition is true so the modal layout stays clean.
 */
export const EmptyOrSkippedBanner: React.FC<Props> = ({ empty, skippedSheets }) => {
  const hasSkipped = skippedSheets.length > 0
  if (!empty && !hasSkipped) return null

  return (
    <div className={styles.container}>
      {empty && (
        <div className={styles.banner} role="alert">
          <span className={styles.icon} aria-hidden>⚠</span>
          <span>Excel 파일에 데이터 행이 없습니다.</span>
        </div>
      )}
      {hasSkipped && (
        <div className={styles.banner} role="alert">
          <span className={styles.icon} aria-hidden>⚠</span>
          <span>
            알 수 없는 시트 {skippedSheets.length}개가 무시되었습니다:{' '}
            <code className={styles.sheetList}>{skippedSheets.join(', ')}</code>
          </span>
        </div>
      )}
    </div>
  )
}
